// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__uyVwL","termsConditions":"Footer_termsConditions__qb8zQ","bbbLink":"Footer_bbbLink__NaVkI"};